import StrapiPageSEO from './StrapiPageSEO';

export default StrapiPageSEO;
